import OVERSEER from 'Services/NewUserPermissionsService'

const MODEL_NAME = 'Bid'

export default class BidPolicy {
  _record = undefined

  constructor (record) {
    this._record = record

    this._canView = OVERSEER.queryPermissions(MODEL_NAME, this._record, 'bid.view')
  }

  get canView () { return this._canView.can }
}
